<template>
  <div class="table-toggle w-dropdown-toggle" tabindex="0" @click="$emit('open')">
    <div class="table-item">
      <div class="text-secondary">#{{ order.id }}</div>
    </div>
    <div class="table-item">
      <template v-if="changePatientClient">
        <div :title="order.client_name" class="patient-title">{{ order.client_name }}</div>
        <div class="text-secondary">{{ order.patient }}</div>
      </template>
      <template v-else>
        <div :title="order.patient" class="patient-title">{{ order.patient }}</div>
        <div class="text-secondary">{{ order.client_name }}</div>
      </template>
    </div>
    <div class="order-details">
      <div class="table-item">
        <div class="text nowrap">Создан {{ date.created }}</div>
        <div v-if="!hideReadyDate && !['completed', 'rejected'].includes(tab)" class="text-secondary">Будет готов ≈ {{ date.deadline }}</div>
        <div v-if="!hideReadyDate && tab === 'completed'" class="text-secondary">Был готов {{ date.deadline }}</div>
      </div>
      <div class="table-item">
        <div class="text text-nowrap">
          {{ numberOfProducts }}
          <span v-if="order.is_milling_request_sent" class="status mill">фрезеровать</span>
        </div>
        <div class="text-secondary">{{ numberOfFiles }}</div>
      </div>
    </div>

    <div v-if="additional === 'employee'" class="table-item">
      <div class="text-secondary d-hidden">Исполнитель</div>
      <div :title="order.responsible_name" class="employee-title">{{ order.responsible_name }}</div>
    </div>

    <div v-if="!hidePrice" class="table-item">
      <div class="text text-table-price">{{ price }} ₽</div>
    </div>

    <!--
      First 5 cells are always of the same time, but the 6th and 7th can be added with
      the different types: status, reason, to_work, employee, end.
    -->

    <div v-if="additional === 'status'" class="table-item ti-status">
      <div :class="order.status === 'new' ? 'waiting' : 'inwork'" class="status">
        {{ order.status === 'new' ? 'В ожидании' : 'В работе' }}
      </div>
    </div>

    <div v-if="additional === 'reason'" class="table-item">
      <div class="reason-wrap">
        <div class="reason">{{ order.rejection_reason }}</div>
        <div class="hint">{{ order.rejection_reason }}</div>
      </div>
    </div>

    <div v-else-if="additional === 'to_work'" class="table-item table-item-hor">
      <div class="btn-primary w-inline-block" @click.stop="toWork">
        <div>В работу</div>
      </div>
      <div class="cancel-application w-inline-block" @click.stop="cancel">
        <div class="icon-20px">
          <CloseIcon />
        </div>
        <div class="hint hint-small">Отклонить</div>
      </div>
      <div class="btn-text d-hidden w-inline-block" @click.stop="cancel">
        <div>Отклонить</div>
      </div>
    </div>

    <div v-if="additional2 === 'end'" class="table-item table-item-hor">
      <div class="btn-secondary w-inline-block" @click.stop="end">
        <div>Завершить</div>
      </div>
    </div>

    <div v-if="additional2 === 'end-or-reject'" class="table-item table-item-hor">
      <div class="btn-secondary w-inline-block" @click.stop="end">
        <div>Завершить</div>
      </div>
      <div class="cancel-application w-inline-block" @click.stop="cancel">
        <div class="icon-20px">
          <CloseIcon />
        </div>
        <div class="hint hint-small">Отклонить</div>
      </div>
      <div class="btn-text d-hidden w-inline-block" @click.stop="cancel">
        <div>Отклонить</div>
      </div>
    </div>

    <div v-else-if="additional2 === 'to_milling'" class="table-item align-right">
      <div v-if="order.is_milling_request_sent" class="status waiting">
        Заказ на фрезеровку отправлен
      </div>
      <div v-else class="btn-primary w-inline-block" @click.stop="toMilling">
        <div>Фрезеровать</div>
      </div>
    </div>

    <div :class="{rotate: open}" class="table-item table-chevron">
      <div class="icon-12px">
        <ChevronIcon />
      </div>
    </div>
  </div>
</template>

<script>
  import CloseIcon from '@/icons/close.svg';
  import ChevronIcon from '@/icons/chevron.svg';
  import formatDate from '@/utils/formatting/format-date';
  import addSpaces from '@/utils/formatting/add-spaces';
  import {mapActions, mapState} from 'vuex';
  import EndOrderModal from '@/containers/orders/actions/EndOrderModal';
  import ToWorkModal from '@/containers/orders/actions/ToWorkModal';
  import ToMillingModal from '@/containers/orders/actions/ToMillingModal';
  import CancelOrderModal from '@/containers/orders/actions/CancelOrderModal';
  import declOfNum from '@/utils/formatting/decl-of-num';
  export default {
    name: 'TableRow',
    components: {
      CloseIcon,
      ChevronIcon,
    },
    props: {
      order: {
        type: Object,
        required: true,
      },
      additional: String,
      additional2: String,
      open: Boolean,
      hidePrice: Boolean,
      changePatientClient: Boolean,
      tab: String,
    },
    computed: {
      date () {
        return {
          created: formatDate(this.order.created_at),
          deadline: formatDate(this.order.deadline),
        };
      },
      price () {
        return addSpaces(this.order.full_price);
      },
      ...mapState({
        role: state => state.auth?.user?.role || '',
      }),
      hideReadyDate () {
        return this.order.status === 'new' && this.role === 'client';
      },
      products () {
        return this.order.products || [];
      },
      numberOfProducts () {
        return `${this.products.length} ${declOfNum(this.products.length, ['изделие', 'изделия', 'изделий'])}`;
      },
      numberOfFiles () {
        return `${this.order.client_scans.length} ${declOfNum(this.products.length, ['файл', 'файла', 'файлов'])}`;
      },
    },
    created() {
    },
    methods: {
      ...mapActions({
        openModal: 'modal/openModal',
      }),
      end () {
        this.openModal({
          component: EndOrderModal,
          context: {
            id: this.order.id,
            attributes: {
              windowClass: 'window-fixed',
              class: 'popup-close-application',
            },
          },
        });
      },
      toWork () {
        this.openModal({
          component: ToWorkModal,
          context: {
            id: this.order.id,
            attributes: {
              windowClass: 'w-clearfix',
              class: 'popup-work',
            },
          },
        });
      },
      toMilling () {
        this.openModal({
          component: ToMillingModal,
          context: {
            id: this.order.id,
            attributes: {
              windowClass: 'w-clearfix',
              class: 'popup-milling',
            },
          },
        });
      },
      cancel () {
        this.openModal({
          component: CancelOrderModal,
          context: {
            id: this.order.id,
            attributes: {
              windowClass: 'w-clearfix',
              class: 'popup-cancel',
            },
          },
        });
      },
    },
  };
</script>

<style scoped>
  .nowrap {
    white-space: nowrap;
  }
  .table-chevron .icon-12px {
    transform: rotate(0deg);
    transition: transform .3s;
  }
  .table-chevron.rotate .icon-12px {
    transform: rotate(180deg);
    transition: transform .3s;
  }
</style>
